<template>
  <transition name="modal-fade">
    <Modal @close="close">
      <div class="ly_pop_content ly_pop_msg ly_txt">
        <div class="ly_pop_head">
          <a class="btn_ly_close svg_close" @click="close"
            ><span>{{ $t('library.deletemodal.close') }}</span></a
          >
        </div>
        <div class="ly_inner">
          <div class="tac">
            <img
              src="@/assets/images/vis/slefbook_pubplish.png"
              width="124px"
            />
          </div>
          <p class="tac cb fw">
            {{ $t('selfbook.confirmeditmodal.3427') }}<br />{{
              $t('selfbook.confirmeditmodal.4652')
            }}
          </p>
          <div class="btn_wrap">
            <button class="box_btn dull" @click="close">
              <span class="an_t">{{ $t('library.deletemodal.cancel') }}</span>
            </button>
            <button class="box_btn" @click="openInEditor">
              <span class="an_t">{{
                $t('selfbook.confirmeditmodal.995')
              }}</span>
            </button>
          </div>
        </div>
      </div>
    </Modal>
  </transition>
</template>

<script>
export default {
  name: 'ConfirmEditModal',
  methods: {
    close() {
      this.$emit('close')
    },
    openInEditor() {
      // ADD action to send user to editor site + pass the file's S3 URI
    }
  }
}
</script>

<style lang="scss" scoped>
.box_btn {
  margin-left: 6px !important;
  margin-right: 6px !important;
}
</style>
